import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Divider, Tabs } from '@telus-uds/components-web';

import SalesRepDashboard from '../../salesRepDashboard';
import ContactCentreSalesRepDashboard from '../../ContactCentre/salesRepDashboard';
import Orders from '../../orders';
import BAOrderFulFillmentDashboard from '../../businessApps/businessAppsOrderFulfillmentDashboard';
import QuoteApprovalDashboard from '../../QuoteApprovalDashboard';
import { CONSTANT } from '../../utils/constant';
import BusinessAppOrders from '../../businessApps/businessAppsSalesRepDashboard';
import IotSalesRepDashboard from '../../iot/iotMyOrdersDashboard';
import IotOrderFulfillmentDashboard from '../../iot/iotOrderFulfillmentDashboard';

// import ResponsiveTable from '../../common/responsiveTable';

const Dashboards = ({ availableDashboards, location }) => {
  if (availableDashboards.length === 0) return null;

  const [selectedDashboard, setSelectedDashboard] = useState('');

  useEffect(() => {
    setSelectedDashboard(availableDashboards[0]);
  }, [availableDashboards]);

  const getDashboard = key => {
    switch (key) {
      case 'SALES_REP_DASHBOARD':
        return <SalesRepDashboard location={location} />;
      // return <ResponsiveTable />;
      case 'CC_SALES_REP_DASHBOARD':
        return <ContactCentreSalesRepDashboard location={location} />;
      case 'SOV_DASHBOARD':
        return <Orders />;
      case 'QUOTE_APPROVAL_DASHBOARD':
        return <QuoteApprovalDashboard />;
      case 'BUSINESS_APP_DASHBOARD':
        return <BusinessAppOrders />;
      case 'IOT_SALES_REP_DASHBOARD':
        return <IotSalesRepDashboard />;
      case 'BA_SALES_REP_DASHBOARD':
        return <BusinessAppOrders />;
      case 'BA_ORDER_FULFILLMENT_DASHBOARD':
        return <BAOrderFulFillmentDashboard />;
      case 'IOT_SOV_DASHBOARD':
        return <IotOrderFulfillmentDashboard />;
      default:
        return null;
    }
  };

  const tabItems = availableDashboards.map(dashboard => ({
    id: dashboard,
    label: CONSTANT.DASHBOARD_LABELS[dashboard] || dashboard
  }));

  return (
    <>
      <div style={{ maxWidth: '99%', margin: '0 auto' }}>
        <Tabs
          value={selectedDashboard}
          onChange={setSelectedDashboard}
          items={tabItems}
          itemTokens={{ maxWidth: 'none', borderWidth: 1, borderColor: '#D8D8D8', marginHorizontal: 4 }}
        />
      </div>
      
      <Divider space={2} variant={{ inverse: true }} />
      
      {getDashboard(selectedDashboard)}
    </>
  );
};

Dashboards.propTypes = {
  availableDashboards: PropTypes.arrayOf(PropTypes.string).isRequired,
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default Dashboards;
